import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { CustomerServiceService } from "src/app/customer/customer-service.service";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";
import { AdminService } from "src/app/admin/admin.service";
import { TruckOwnerService } from "src/app/truck-owner/truck-owner.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AdminAddDriverComponent } from "src/app/admin/admin-add-driver/admin-add-driver.component";
import { Router } from "@angular/router";

@Component({
  selector: "app-otp-verify",
  templateUrl: "./otp-verify.component.html",
  styleUrls: ["./otp-verify.component.css"],
})
export class OtpVerifyComponent implements OnInit {
  otpForm!: FormGroup;
  code: any;
  customerData: any;
  otpWrongErrorMsg: boolean = false;
  Response: any;
  count: number = 0;
  @ViewChild("ngOtpInput") ngOtpInputRef: any;
  public href: string = "";
  url: string = "";
  verificationCode: boolean = true;
  urlString: string;
  isVerificationInProgress: boolean = false;

  constructor(
    private matDialogref: MatDialogRef<OtpVerifyComponent>,
    private formBuilder: FormBuilder,
    private services: CustomerServiceService,
    private adminService: AdminService,
    private service: TruckOwnerService,
    private snackBar: MatSnackBar,
    private router: Router,
    private matdialogref: MatDialogRef<AdminAddDriverComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Ensure you have this flag in your component
  ) {}

  ngOnInit(): void {
    this.customerData = this.data;
    this.otpForm = this.formBuilder.group({
      code: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^\d{6}$/),
        ]),
      ],
    });
    this.SendOtp();
    this.href = this.router.url;
    const admin = this.href.split("admin");
    this.urlString = admin[1]?.substring(1);
    if (this.urlString === "drivers") {
      this.verificationCode = true;
    } else if (this.urlString === "users") {
      this.verificationCode = true;
    } else {
      this.verificationCode = true;
    }
  }

  public SendOtp() {
    if (this.data.dataKey.from === "driver") {
      this.mobileVerification();
    } else if (this.data.dataKey.from === "userCustomer") {
      this.usercustomerVerification();
    } else if (this.data.dataKey.displayText === "email") {
      this.emailOTPRequest();
    } else if (this.data.dataKey.from === "truckowner") {
      this.truckOwnermobileVerification();
    } else {
      this.EmailVerification();
    }
  }

  public EmailVerification(): void {
    const obj = {
      email: this.data.dataKey.email,
    };
    if (this.data.dataKey.email !== null || this.data.dataKey.email !== "") {
      this.services.customerLogin(obj).subscribe(
        (response: any) => {
          this.Response = response;
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  public mobileVerification() {
    const obj = {
      mobile: this.data.dataKey.mobile,
      user_type: this.data.dataKey.user_type,
      ref_id: this.data.dataKey.ref_id,
    };
    if (this.data.dataKey.email !== "") {
      this.services.customerLogin(obj).subscribe(
        (response: any) => {
          this.Response = response;
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }
  public usercustomerVerification() {
    const obj = {
      mobile: this.data.dataKey.mobile,
      user_type: this.data.dataKey.user_type,
    };
    if (this.data.dataKey.email !== "") {
      this.services.userCustomerVerify(obj).subscribe(
        (response: any) => {
          this.Response = response.data;
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  public truckOwnermobileVerification() {
    const obj = {
      mobile: this.data.dataKey.email,
      user_type: this.data.dataKey.user_type,
    };
    if (this.data.dataKey.email !== "") {
      this.services.truckownerDriverLogin(obj).subscribe(
        (response: any) => {
          this.Response = response.data;
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  emailOTPRequest() {
    const emailObj = {
      email: this.data.dataKey.email,
    };
    if (this.data.dataKey.email !== "") {
      this.service.emailRequest(emailObj).subscribe(
        (response: any) => {
          this.Response = response.data;
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  public truckOwnerEmailVerification(code: any) {
    var token = sessionStorage.getItem("to_token");
    const obj = {
      email: this.data.dataKey.email,
      code: code,
      user_type: "driver",
    };
    if (this.data.dataKey.email !== "") {
      this.service.EmailOTPVerify(obj, this.Response._id, token).subscribe(
        (response: any) => {
          this.Response = response.data;
          this.matDialogref.close({ event: "Success" });
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  public clear(): void {
    this.matDialogref.close({ event: "Cancel" });
  }
  onOtpChange(code: string): void {
    if (code.length == 4) {
      this.verifyOtp(code);
    }
  }

  // public onOtpChange(code: string): void {
  //   if (code.length == 6 && this.count == 0) {
  //     this.count = this.count + 1;
  //     this.verifyOtp(code);
  //   }
  // }

  public verifyOtp(code: any): void {
    if (this.data.dataKey.from === "driver") {
      this.verifyDriverOtp(code);
    } else if (this.data.dataKey.from === "userCustomer") {
      this.verifycustomersOtp(code);
    } else if (this.data.dataKey.displayText === "email") {
      this.truckOwnerEmailVerification(code);
    } else if (this.data.dataKey.from === "truckowner") {
      this.verifyTruckOwnerDriverOtp(code);
    } else {
      this.verifyCustomerOtp(code);
    }
  }

  public verifyCustomerOtp(code: any): void {
    this.otpWrongErrorMsg = false;
    const verifyEmailData = {
      email: this.data.dataKey.email,
      code: code,
    };
    this.services.EmailOTPVerify(verifyEmailData, this.Response._id).subscribe(
      (response: any) => {
        this.matDialogref.close();
      },
      (error) => {
        if (error.status == 400) {
          this.otpWrongErrorMsg = true;
        }
      }
    );
  }

  public verifyDriverOtp(code: any): void {
    // Prevent multiple calls by disabling the button or setting a flag
    if (this.isVerificationInProgress) {
      return;
    }
    this.isVerificationInProgress = true;
    var token = localStorage.getItem("adminToken");
    this.otpWrongErrorMsg = false;
    const verifyData = {
      mobile: this.data.dataKey.mobile,
      code: code,
      user_type: this.data.dataKey.from,
      ref_id: this.data.dataKey.ref_id,
    };

    this.adminService
      .MobileOTPVerify(verifyData, this.Response._id, token)
      .subscribe(
        (response: any) => {
          this.isVerificationInProgress = false;

          if (response.status === 201 || response.status === 200) {
            sessionStorage.setItem("driverRegId", response.body.data._id);
            if (response.body.data.driver_status === "offline") {
              this.snackBar.open("Mobile Number is Already Used ", "Success", {
                duration: 5000,
              });
              this.matDialogref.close({ event: "Failure" });
            } else {
              this.matDialogref.close({ event: "Success" });
            }
          } else if (response.status === 400) {
            this.otpWrongErrorMsg = true;
          }
        },
        (error) => {
          this.isVerificationInProgress = false;

          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  public verifycustomersOtp(code: any): void {
    var token = localStorage.getItem("token");
    this.otpWrongErrorMsg = false;
    const otpObj = {
      mobile: this.data.dataKey.mobile,
      code: code,
      user_type: this.data.dataKey.from,
      ref_id: this.data.dataKey.ref_id,
    };
    this.services.verifyOTP(otpObj, this.Response._id, token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          localStorage.setItem("userCustomer", response.body.data._id);
          if (response.body.data.driver_status === "offline") {
            this.snackBar.open("Mobile Number is Already Used ", "Success", {
              duration: 5000,
            });
          }
          this.matDialogref.close({ event: "Success" });
        } else if (response.status === 400) {
          this.otpWrongErrorMsg = true;
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  public verifyTruckOwnerDriverOtp(code: any): void {
    // Prevent multiple calls by disabling the button or setting a flag
    if (this.isVerificationInProgress) {
      return;
    }
    this.isVerificationInProgress = true;
    var token = sessionStorage.getItem("to_token");
    this.otpWrongErrorMsg = false;
    const verifyData = {
      mobile: this.data.dataKey.email,
      code: code,
      user_type: "driver",
    };
    this.service
      .MobileTruckOwnerOTPVerify(verifyData, this.Response._id, token)
      .subscribe(
        (response: any) => {
          this.isVerificationInProgress = false;

          if (response.status === 201) {
            this.ngOtpInputRef.setValue(null);
            sessionStorage.setItem("driverRegId", response.body.data._id);
            this.matDialogref.close({ event: "Success" });
          } else if (response.status === 400) {
            this.otpWrongErrorMsg = true;
          }
        },
        (error) => {
          this.isVerificationInProgress = false;

          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  resendOTP() {
    if (this.data.dataKey.from === "driver") {
      this.mobileVerification();
    } else if (this.data.dataKey.from === "userCustomer") {
      this.usercustomerVerification();
    } else if (this.data.dataKey.displayText === "email") {
      this.emailOTPRequest();
    } else if (this.data.dataKey.from === "truckowner") {
      this.truckOwnermobileVerification();
    } else {
      this.EmailVerification();
    }
  }
}
